<div class="">
  <div class="mx-auto mb-10">
    <div class="flex justify-between items-center">
      <h2 class="text-4xl font-bold text-gray-800">Dashboard</h2>
      <p class="hidden lg:inline text-gray-600">
        Welcome back! Here's your organization overview
      </p>
    </div>
    <p class="lg:hidden text-gray-600 pt-2">
      Welcome back! Here's your organization overview
    </p>
  </div>

  <!-- Stats Grid -->
  <div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-6 mb-6">
    <!-- Total Employees Card -->
    <div
      class="bg-blue-100 rounded-2xl shadow-lg overflow-hidden transition-all duration-300 border-b-4 border-blue-500"
      [class.hover:shadow-xl]="totalEmployees() > 0 && !loadingEmployees()"
      [class.opacity-60]="totalEmployees() === 0 || loadingEmployees()"
      tabindex="0"
    >
      <div class="p-8">
        <div class="flex items-center gap-8">
          <div
            class="w-20 h-20 bg-blue-500 rounded-xl flex items-center justify-center shadow-lg"
          >
            <app-users-icon className="w-10 h-10 text-white" />
          </div>

          <div>
            <p class="text-base 2xl:text-xl font-medium text-gray-600">
              Total Employees
            </p>
            <p class="text-4xl font-bold text-gray-800">
              {{ loadingEmployees() ? "..." : totalEmployees() }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Total Departments Card -->
    <div
      class="bg-green-100 rounded-2xl shadow-lg overflow-hidden transition-all duration-300 border-b-4 border-green-500"
      [class.hover:shadow-xl]="totalEmployees() > 0 && !loadingEmployees()"
      [class.opacity-60]="totalDepartments() === 0 || loadingDepartments()"
      tabindex="0"
    >
      <div class="p-8">
        <div class="flex items-center gap-8">
          <div
            class="w-20 h-20 bg-green-500 rounded-xl flex items-center justify-center shadow-lg"
          >
            <app-org-icon className="w-10 h-10 text-white" />
          </div>

          <div>
            <p class="text-base 2xl:text-xl font-medium text-gray-600">
              Total Departments
            </p>
            <p class="text-4xl font-bold text-gray-800">
              {{ loadingDepartments() ? "..." : totalDepartments() }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Active vs Inactive Employees Card -->
    <div
      class="bg-purple-100 rounded-2xl shadow-lg overflow-hidden transition-all duration-300 border-b-4 border-purple-500"
      [class.opacity-60]="loadingEmployeeStatusCount()"
      [class.hover:shadow-xl]="totalEmployees() > 0 && !loadingEmployees()"
    >
      <div class="p-8">
        <div class="flex items-center gap-8">
          <!-- Icon -->
          <div
            class="w-20 h-20 bg-purple-500 rounded-xl flex items-center justify-center shadow-lg"
          >
            <app-pie-chart-icon className="w-10 h-10 text-white" />
          </div>

          <!-- Content -->
          <div class="flex-1">
            <p class="text-base 2xl:text-xl font-medium text-gray-600 mb-2">
              Employee Status
            </p>

            <div class="flex items-center gap-6">
              <!-- Active -->
              <div>
                <p class="text-sm font-medium text-green-600">Active</p>
                <p class="text-3xl font-bold">
                  {{ loadingEmployeeStatusCount() ? "..." : activeEmployees() }}
                </p>
              </div>

              <!-- Divider -->
              <div class="h-10 w-px bg-gray-300"></div>

              <!-- Inactive -->
              <div>
                <p class="text-sm font-medium text-red-600">Inactive</p>
                <p class="text-3xl font-bold">
                  {{
                    loadingEmployeeStatusCount() ? "..." : inactiveEmployees()
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Stats Summary Card -->
    <div
      class="bg-yellow-100 rounded-2xl shadow-lg overflow-hidden transition-all duration-300 border-b-4 border-yellow-500 col-span-1 lg:col-span-2 xl:col-span-1 2xl:col-span-1"
      [class.hover:shadow-xl]="totalEmployees() > 0"
      [class.opacity-60]="
        loadingEmployees() ||
        loadingDepartments() ||
        loadingEmployeeStatusCount()
      "
    >
      <div class="p-8">
        <div class="flex items-center gap-8">
          <!-- Icon -->
          <div
            class="w-20 h-20 bg-yellow-500 rounded-xl flex items-center justify-center shadow-lg shrink-0"
          >
            <app-bar-chart-icon className="w-10 h-10 text-white" />
          </div>

          <!-- Content -->
          <div class="flex-1">
            <p class="text-base 2xl:text-xl font-medium text-gray-600 mb-3">
              Quick Insights
            </p>

            <div class="grid grid-cols-2 gap-4">
              <!-- Active Rate -->
              <div>
                <p class="text-sm font-medium text-yellow-600 mb-1">
                  Active Rate
                </p>
                <p class="text-3xl font-bold text-gray-800">
                  {{
                    loadingEmployeeStatusCount() ? "..." : activeRate() + "%"
                  }}
                </p>
              </div>

              <!-- Avg Dept Size -->
              <div>
                <p class="text-sm font-medium text-yellow-600 mb-1">
                  Avg Dept Size
                </p>
                <p class="text-3xl font-bold text-gray-800">
                  {{
                    loadingEmployees() || loadingDepartments()
                      ? "..."
                      : avgDeptSize()
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Placeholder for future stat (optional) -->
  <!-- <div class="bg-purple-100 rounded-2xl shadow-lg overflow-hidden">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <div
            class="w-14 h-14 bg-purple-500 rounded-xl flex items-center justify-center shadow-lg"
          >
            <svg
              class="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              ></path>
            </svg>
          </div>
        </div>
        <h3 class="text-gray-600 text-sm font-medium mb-1">Active Rate</h3>
        <p class="text-4xl font-bold text-gray-800">--</p>
        <p class="text-xs text-purple-600 mt-2 font-medium">Coming soon</p>
      </div>
      <div class="h-1 bg-purple-500"></div>
    </div> -->

  <!-- Quick Actions Section -->
  <div class="bg-white rounded-2xl shadow-lg p-8 mb-6">
    <h3 class="text-2xl font-bold text-gray-800 mb-6">Quick Actions</h3>

    <div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-4">
      <!-- Add Employee -->
      <button
        routerLink="/employee/add"
        class="flex items-center space-x-3 p-4 rounded-xl border-2 border-blue-200 bg-blue-50 hover:bg-blue-100 hover:border-blue-300 transition-all duration-300 group"
      >
        <div
          class="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform"
        >
          <app-add-icon />
        </div>
        <div class="text-left">
          <div class="font-semibold text-gray-800">Add Employee</div>
          <div class="text-sm text-gray-600">Create new employee</div>
        </div>
      </button>

      <!-- Add Department -->
      <button
        routerLink="/department/add"
        class="flex items-center space-x-3 p-4 rounded-xl border-2 border-green-200 bg-green-50 hover:bg-green-100 hover:border-green-300 transition-all group"
      >
        <div
          class="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform"
        >
          <app-add-icon />
        </div>
        <div class="text-left">
          <div class="font-semibold text-gray-800">Add Department</div>
          <div class="text-sm text-gray-600">Create new department</div>
        </div>
      </button>

      <!-- View All Employees -->
      <button
        routerLink="/employee"
        class="flex items-center space-x-3 p-4 rounded-xl border-2 border-purple-200 bg-purple-50 hover:bg-purple-100 hover:border-purple-300 transition-all group"
      >
        <div
          class="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform"
        >
          <app-users-icon className="w-6 h-6" />
        </div>
        <div class="text-left">
          <div class="font-semibold text-gray-800">All Employees</div>
          <div class="text-sm text-gray-600">View employee list</div>
        </div>
      </button>

      <!-- View All Departments -->

      <button
        routerLink="/department"
        class="flex items-center space-x-3 p-4 rounded-xl border-2 border-yellow-200 bg-yellow-50 hover:bg-yellow-100 hover:border-yellow-300 transition-all group"
      >
        <div
          class="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center text-white group-hover:scale-110 transition-transform"
        >
          <app-org-icon />
        </div>
        <div class="text-left">
          <div class="font-semibold text-gray-800">All Departments</div>
          <div class="text-sm text-gray-600">View department list</div>
        </div>
      </button>
    </div>
  </div>
</div>
